module.exports = __webpack_public_path__ + "img/im_hero_bg_mob.c3f69dd7.jpg";